import  ApiService  from '../../services/api.service';
const state= {
    service_points: [],
    searchZipCode: '',
    loading: false,
    strAddress: '',
    strAddressWS: '',
    tempAddress: null,
    selectedServicePoint: null,
    tyre_category : null
}
const getters= {
    service_points: (state) => state.service_points,
    loading: (state) => state.loading,
    searchZipCode: (state) => state.searchZipCode,
    strAddress: (state) => state.strAddress,
    strAddressWS: (state) => state.strAddressWS,
    getTempAddress:  (state) => state.tempAddress,
    selectedServicePoint:  (state) => state.selectedServicePoint,
    tyre_category:  (state) => state.tyre_category,
}
const actions= {
    async fetchDealers({commit}, params) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('/search-dealers?'+params)
                .then(response => {
                    commit('setServicePointList', response.data)
                    resolve()
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        })
    },

    async getTyreCategoryByVehicleType({commit}, vehicle_type) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get(`/get-search-slug-by-vehicle-type/${vehicle_type}`)
                .then(response => {
                    commit('setTyreCategory', response.data)
                    resolve()
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        })
    },

    setSearchedZipcode({commit}, zipcode) {
        commit('setSearchZipcode', zipcode)
    },
    setStrAddress({commit}, value) {
        commit('setStateStrAddress', value)
    },
    setStrAddressWS({commit}, value) {
        commit('setStateStrAddressWS', value)
    },
    setTempAddress({commit}, value) {
        commit('setStateTempAddress', value)
    },
    setDealers({commit}, value) {
        commit('setServicePointList', value)
    },
    setSelectedServicePoint({commit}, value) {
        commit('setSelectedServicePoint', value)
    }
}
const mutations= {
    setLoading(state, status) {
        state.loading = status
    },
    setServicePointList(state, services) {
        state.service_points = services
    },
    setSearchZipcode(state, zipcode) {
        state.searchZipCode = zipcode
    },
    setStateStrAddress(state, value) {
        state.strAddress = value
    },
    setStateStrAddressWS(state, value) {
        state.strAddressWS = value
    },
    setStateTempAddress(state, value) {
        state.tempAddress = value
    },
    setSelectedServicePoint(state, value) {
        state.selectedServicePoint = value
    },
    setTyreCategory(state, value) {
        state.tyre_category = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}